import React from "react";
import ReactDOM from "react-dom";
import ReactSVG from "react-svg";
import { FormattedMessage } from "react-intl";
import * as S from "./styles";

var closeWhite = require("../../../../images/closewhite.svg");

var ManualTransferReceiptAlert = function ManualTransferReceiptAlert(_ref) {
  var message = _ref.message,
      onClose = _ref.onClose,
      onAddReceipt = _ref.onAddReceipt;
  var modalContent = React.createElement(S.ModalRoot, null, React.createElement(S.ModalOverlay, {
    onClick: onClose,
    "data-test": "manualTransferReceiptAlertOverlay"
  }), React.createElement(S.ModalPanel, {
    "data-test": "manualTransferReceiptAlert"
  }, React.createElement(S.ModalHeader, null, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferReceiptAlert.2977696296",
    defaultMessage: "Alerta"
  })), React.createElement(ReactSVG, {
    path: closeWhite,
    onClick: onClose
  })), React.createElement(S.ModalBody, null, message), React.createElement(S.ModalFooter, null, React.createElement(S.ModalActionButton, {
    type: "button",
    "data-test": "manualTransferAddReceiptButton",
    onClick: onAddReceipt
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferReceiptAlert.3807589440",
    defaultMessage: "Agregar comprobante"
  })))));

  if (typeof document === "undefined") {
    return modalContent;
  }

  return ReactDOM.createPortal(modalContent, document.body);
};

export { ManualTransferReceiptAlert };